var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _class, _class2, _descriptor, _descriptor2;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */
import { Component, Prop, Watch } from '@sick-davinci/ce-decorators';
import { ColoredDataElement } from '../_utils/ColoredDataElement.js'; // should be imported first, so css variables from theme-base are available

import { CategoryAxisBuilder } from '../_utils/CategoryAxisBuilder.js';
import { createValuesGridStyle } from '../_utils/StyleTools.js';
import { ValueRangeScale } from '../_utils/ValueRange.js';
import { ValueRangeTools } from '../_utils/ValueRangeTools.js';
import { ThemeService } from '../_utils/ThemeService.js';
import { sanitizeJustifyContent } from '../_utils/JustifyContent.js';
/**
 * A base class for bar charts
 */

export let AbstractBarChart = (_dec = Component({
  abstract: true
}), _dec2 = Reflect.metadata("design:paramtypes", [Object]), _dec3 = Prop(), _dec4 = Reflect.metadata("design:type", Number), _dec5 = Watch('decimalPlaces'), _dec6 = Reflect.metadata("design:paramtypes", []), _dec7 = Prop(), _dec8 = Reflect.metadata("design:type", String), _dec9 = Prop({
  type: String
}), _dec10 = Reflect.metadata("design:type", Object), _dec11 = Prop(), _dec12 = Reflect.metadata("design:type", Boolean), _dec13 = Prop(), _dec14 = Reflect.metadata("design:type", Object), _dec15 = Prop(), _dec16 = Reflect.metadata("design:type", Object), _dec17 = Watch('palette'), _dec18 = Reflect.metadata("design:paramtypes", []), _dec(_class = _dec2(_class = (_class2 = class AbstractBarChart extends ColoredDataElement {
  /**
   * The range (minimum and maximum value) that is used to scale bars.
   */

  /**
   * The labels for the categories
   */

  /**
   * The icons for the categories
   */

  /**
   * The values; the first dimension denotes the index of the category, the second dimension the index of the bar/section; that is, value[2][4] stores the value of the 5th bar/section within the 3rd category
   */

  /**
   * Whether the bar chart is horizontal (true) or vertical (false)
   */

  /**
   * The title of the catgory axis
   */
  constructor(seriesColors) {
    super();
    this._categoryLabels = [];
    this._categoryIcons = [];
    this._values = [];
    this._horizontal = false;
    this._categoryAxisTitle = '';

    _initializerDefineProperty(this, "decimalPlaces", _descriptor, this);

    this._justifyCategoryAxis = 'SpaceGreedily';

    _initializerDefineProperty(this, "legendLabels", _descriptor2, this);

    this._themeListener = () => {
      this._updateStyle();
    };

    if (seriesColors) {
      this._setSeriesColors(seriesColors);
    }
  }
  /**
   * The number of decimal places to use. Possible values are from 0 to 10.
   *
   * If undefined no fixed number of decimal places will be used.
   *
   * @default undefined
   */


  decimalPlacesWatcher() {
    this._updateStyle();
  }
  /**
   * The title of the category axis.
   *
   * Blank strings will be treated as if no title is set.
   *
   * @default empty string
   */


  get categoryAxisTitle() {
    return this._categoryAxisTitle;
  }

  set categoryAxisTitle(value) {
    this._categoryAxisTitle = value;

    this._updateStyle();
  }

  /**
   * Defines how labels and icons of the category axis are layouted.
   *
   * @default 'SpaceGreedily'
   */
  get justifyCategoryAxis() {
    return this._justifyCategoryAxis;
  }

  set justifyCategoryAxis(value) {
    this._justifyCategoryAxis = sanitizeJustifyContent(value, 'SpaceGreedily');

    this._updateStyle();
  }
  /**
   * Whether the bar chart is horizontal (true) or vertical (false)
   *
   * @default false
   */


  get horizontal() {
    return this._horizontal;
  }

  set horizontal(value) {
    this._horizontal = value;

    this._updateStyle();
  }
  /**
   * The range (minimum and maximum value) that is used to scale bars.
   * This range may be set by the user.
   * Undefined values will be automatically computed from the bar values.
   * An undefined scale will be treated as a linear scale.
   *
   * Please note that the minimum value must be less than the maximum value.
   * Also, the minimum value and the maximum value must be greater than 0 if
   * the value range has a logarithmic scale.
   *
   * Not every type of bar chart supports a logarithmic range. Please refer to
   * the documentation of the bar chart itself to determine if a logarithmic range
   * is supported.
   *
   * @default undefined
   */


  get valueRange() {
    return this._valueRange;
  }

  set valueRange(value) {
    this._valueRange = value;

    this._updateStyle();
  }
  /**
   * List of all legend-labels. if not set, no legend is displayed.
   */


  /**
   * Sets the labels to be used for the categories.
   *
   * @param labels - the labels to be used for the categories
   */
  _setCategoryLabels(labels) {
    this._categoryLabels = labels;

    this._updateData();

    this._updateStyle();
  }
  /**
   * Gets the labels to be used for the categories.
   *
   * @returns the labels to be used for the categories
   */


  _getCategoryLabels() {
    return this._categoryLabels;
  }
  /**
   * Sets the icons to be used for the categories.
   *
   * @param icons - the icons to be used for the categories
   */


  _setCategoryIcons(icons) {
    this._categoryIcons = icons;

    this._updateData();

    this._updateStyle();
  }
  /**
   * Gets the icons to be used for the categories.
   *
   * @returns the icons to be used for the categories
   */


  _getCategoryIcons() {
    return this._categoryIcons;
  }
  /**
   * Sets the values to be used for the bars.
   *
   * Beware that the order of values should reflect the order of colors if the 'state' color palette is active.
   *
   * @param values - a two dimensional array; the first dimension denotes the index of the group/bar, the second dimension the index of the bar/segment; that is, value[2][4] stores the value of the 5th bar/segment of the 3rd group/bar
   */


  _setValues(values) {
    // map Infinity, -Infinity and NaN to 0
    this._values = values.map(arr => arr.map(value => Number.isFinite(value) ? value : 0.0));

    this._updateData();

    this._updateStyle(); // we need to recalculate the value range

  }
  /**
   * Gets the values to be used for the bars.
   *
   * @returns a two dimensional array; the first dimension denotes the index of the group/bar, the second dimension the index of the bar/segment; that is, value[2][4] stores the value of the 5th bar/segment of the 3rd group/bar
   */


  _getValues() {
    return this._values;
  }
  /**
   * recycle holder the holder: needed, since holds the actual chart as a child
   */


  _getHolder() {
    var _this$shadowRoot;

    let holder = (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.getElementById('holder');

    if (!holder) {
      holder = document.createElement('div');
      holder.setAttribute('id', 'holder');
    }

    return holder;
  }

  paletteWatcher() {
    this._updateStyle();
  }

  _setSeriesColors(colors) {
    super._setSeriesColors(colors);

    this._updateStyle();
  }

  componentConnected() {
    super.componentConnected();
    ThemeService.GET_INSTANCE().addListener(this._themeListener);
  }

  componentDisconnected() {
    super.componentDisconnected();
    ThemeService.GET_INSTANCE().removeListener(this._themeListener);
  }
  /**
   * Updates the data of the bar chart
   *
   * Call this function every time a data-related property changes
   */


  /**
   * Ensures that every category has the same number of values.
   * Missing values are filled in at the end of the values-array.
   * If the values-array is undefined it will remain undefined.
   * @private
   */
  _sanitizeCategoryValues(categories) {
    const maxValuesCount = categories.map(category => {
      var _category$values;

      return ((_category$values = category.values) === null || _category$values === void 0 ? void 0 : _category$values.length) || 0;
    }).reduce((previousValuesCount, currentValuesCount) => Math.max(previousValuesCount, currentValuesCount), 0);
    categories.forEach(category => {
      if (category.values !== undefined) {
        while (category.values.length < maxValuesCount) {
          category.values.push(0.0);
        }
      }
    });
  }

  _createData() {
    const barChartData = {};
    {
      const labels = this._getCategoryLabels();

      const bars = this._ensureMinBarCount(labels.length, barChartData);

      for (let i = 0; i < labels.length; i++) {
        bars[i].label = labels[i];
      }
    }
    {
      const bars = this._ensureMinBarCount(this._categoryIcons.length, barChartData);

      for (let i = 0; i < this._categoryIcons.length; i++) {
        bars[i].image = this._categoryIcons[i];
      }
    }
    {
      const bars = this._ensureMinBarCount(this._values.length, barChartData);

      for (let i = 0; i < this._values.length; i++) {
        bars[i].values = this._values[i];
      }
    }

    this._sanitizeCategoryValues(barChartData.categories);

    return barChartData;
  }

  *_iterator() {
    for (const barValues of this._values) {
      for (const value of barValues) {
        yield value;
      }
    }
  }

  _computeBarValueRange() {
    const computedValueRange = ValueRangeTools.COMPUTE_VALUE_RANGE(this._iterator(), this.valueRange);
    return {
      start: computedValueRange.start,
      end: computedValueRange.end,
      scale: computedValueRange.scale === ValueRangeScale.linear ? 'Linear' : 'Log10'
    };
  }
  /**
   * Ensures that the given data object contains at least the given number of elements.
   * The data object will be filled up with empty objects ({}) if necessary.
   *
   * @param minBarCount - the target minimum bar count.
   * @param barChartData - the data object to modify
   * @returns a reference to the array of bars of the given data object
   */


  _ensureMinBarCount(minBarCount, barChartData) {
    if (!barChartData.categories) {
      barChartData.categories = [];
    }

    while (barChartData.categories.length < minBarCount) {
      barChartData.categories.push({});
    }

    return barChartData.categories;
  }
  /**
   * Updates the style of the bar chart
   *
   * Calls this function every time a style-related property changes
   */


  /**
   * Creates a new style object that should be filled with the specific properties.
   */
  _createStyle(hostFontFamily) {
    const style = {
      horizontal: this._horizontal
    };
    style.valueRange = this._computeBarValueRange();
    const categoryAxisBuilder = new CategoryAxisBuilder();
    categoryAxisBuilder.fontFamily = hostFontFamily;
    categoryAxisBuilder.title = this.categoryAxisTitle;
    categoryAxisBuilder.horizontal = !this.horizontal;
    categoryAxisBuilder.justifyTickContent = this.justifyCategoryAxis;
    categoryAxisBuilder.icons = this._categoryIcons;
    categoryAxisBuilder.labels = this._getCategoryLabels();
    style.categoryAxisStyle = categoryAxisBuilder.build();
    style.categoryAxisStyle.axisLineWidth = 0.0;
    style.gridStyle = createValuesGridStyle(true);
    return style;
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "decimalPlaces", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "decimalPlacesWatcher", [_dec5, _dec6], Object.getOwnPropertyDescriptor(_class2.prototype, "decimalPlacesWatcher"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "categoryAxisTitle", [_dec7, _dec8], Object.getOwnPropertyDescriptor(_class2.prototype, "categoryAxisTitle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "justifyCategoryAxis", [_dec9, _dec10], Object.getOwnPropertyDescriptor(_class2.prototype, "justifyCategoryAxis"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "horizontal", [_dec11, _dec12], Object.getOwnPropertyDescriptor(_class2.prototype, "horizontal"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "valueRange", [_dec13, _dec14], Object.getOwnPropertyDescriptor(_class2.prototype, "valueRange"), _class2.prototype), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "legendLabels", [_dec15, _dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, "paletteWatcher", [_dec17, _dec18], Object.getOwnPropertyDescriptor(_class2.prototype, "paletteWatcher"), _class2.prototype)), _class2)) || _class) || _class);
